module.exports = __webpack_public_path__ + "c66fe40b59ff9f22e5eb46503fe9b135.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/beady-25.png
// module id = 1469
// module chunks = 0